import {
  Add_User_Activation_LogOut_data,
  Add_user_information_data_activation,
  Get_All_user_information_data_activation,
  Get_Error,
} from '../Types';

const intial = {
  user_actiovation: [],
  Get_user_actiovation: [],

  loading: true,
};

const user_Activation_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_user_information_data_activation:
      return {
        ...state,
        user_actiovation: action.payload,
        loading: false,
      };
    case Get_All_user_information_data_activation:
      return {
        ...state,
        Get_user_actiovation: action.payload,
        loading: false,
      };
    case Add_User_Activation_LogOut_data:
      return {
        ...state,
        user_actiovation: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        user_actiovation: action.payload,
      };
    default:
      return state;
  }
};

export default user_Activation_Reducer;
